import { omit } from 'lodash-es';

export function hex2rgb(hex) {
  const match = hex.match(/(\w{2})(\w{2})(\w{2})/);
  const [r, g, b] = match.slice(1).map((s) => parseInt(s, 16));
  return { r, g, b, hex };
}

function prepareTheme(data) {
  const { color, logo, backgroundImage, ...rest } = data;
  rest.themeColor = hex2rgb(color);
  if (logo && typeof logo === 'object') {
    rest.newLogo = omit(logo, ['preview']);
  } else {
    rest.logo = logo;
  }
  if (backgroundImage && typeof backgroundImage === 'object') {
    rest.newBackground = omit(backgroundImage, ['preview']);
  } else {
    rest.backgroundImage = backgroundImage;
  }
  return rest;
}

export default prepareTheme;
